
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Taxiserviceinpune() {



    const cardData =
    {
        keyword: 'Taxi Service in Pune',
        heading: 'Meghana Cab : Taxi Service in Pune',
        headingDescription: 'Meghana Cab offers trusted Taxi Service in Pune, providing quick, safe, and affordable transportation across the city and surrounding areas. Whether you are commuting to work, heading to the airport, or planning a day out, our fleet of clean, well-maintained taxis and professional drivers ensure a smooth ride every time. With easy online booking, transparent fares, and 24/7 customer support, Meghana Cab is your go-to choice for local and outstation travel. Book your Taxi Service in Pune with Meghana Cab and enjoy a hassle-free travel experience',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a significant historical landmark located in the heart of Pune. This majestic fort once served as the seat of Peshwa power and showcases stunning Maratha architecture, large wooden gates, intricate courtyards, and fortified bastions. Though much of it was destroyed in a fire, the remains reflect its grandeur, and the evening light and sound show narrating its history draws many visitors."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892 by Sultan Aga Khan III, holds a pivotal place in India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other national leaders during the Quit India Movement. The palace is set amidst sprawling gardens and houses a museum with rare photos and personal belongings of Gandhi, making it a place of historical and emotional importance for visitors."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located around 30 km from Pune, Sinhagad Fort stands as a symbol of Maratha valor and history. The fort played a key role in the Battle of Sinhagad in 1670, where Tanaji Malusare fought valiantly for Shivaji Maharaj. The fort offers trekking trails, breathtaking views of the Sahyadri mountains, and traditional food stalls serving local dishes like pithla bhakri to reward visitors after the climb."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This fascinating museum is home to over 20,000 artifacts collected by Dr. Dinkar Kelkar, reflecting the rich and diverse cultural heritage of India. The collection includes antique musical instruments, weapons, intricate carvings, traditional household items, and unique sculptures from various time periods. The museum provides an educational experience that connects visitors to India’s artistic and domestic past."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th-century rock-cut shrine dedicated to Lord Shiva, the Pataleshwar Cave Temple is an archaeological gem located in central Pune. Carved out of a single basalt rock, it features finely crafted pillars, a sanctum with a Shiva Lingam, and a circular Nandi Mandapa. Its peaceful surroundings offer a meditative atmosphere for visitors looking to explore ancient architecture in a calm setting."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, this world-renowned retreat founded by spiritual leader Osho offers a variety of meditation and wellness programs. Spread across lush green landscapes with zen-style architecture and tranquil energy, the resort attracts spiritual seekers from around the world. Daily meditation sessions, therapy workshops, and a serene environment make it an ideal place to rejuvenate mentally and physically."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, located about 20 km from Pune, is a favorite weekend destination for families and couples seeking relaxation near nature. Built on the Mutha River, the dam offers cool breezes, scenic views of the water and surrounding hills, and small eateries serving local snacks. It is also the site of the National Defence Academy, making it an important landmark near Pune."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by the famous Korakuen Garden in Okayama, Japan, this well-manicured garden located on Sinhagad Road offers a beautiful blend of Japanese landscaping and Indian greenery. Waterfalls, streams, bridges, and floral layouts make it a peaceful place for families, morning walkers, and photographers seeking natural beauty within the city."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic monument built by Shahaji Bhosale for his son Shivaji Maharaj in the 1630s. Though the original structure was destroyed, the current reconstructed version serves as a museum that reflects Shivaji’s early life through paintings, weapons, and historical narratives. It is an essential stop for anyone interested in Maratha history and legacy."
  },
  {
    "title": "Fergusson College Road",
    "description": "A vibrant street in the Deccan area, Fergusson College Road is known for its youthful energy, thanks to the presence of several colleges nearby. It features a lively mix of cafes, fashion boutiques, bookstores, and street food joints. Whether you’re shopping for trendy clothes or enjoying a plate of momos, this road captures the essence of Pune’s modern-day culture and lifestyle."
  }
],

"services": [
    {
        "name": "Local Taxi Booking Pune",
        "description": "Book reliable local taxis in Pune with Meghana Cab for your daily travel needs. Whether it's a quick city ride, errands, or regular commuting, our local taxi service offers clean vehicles, courteous drivers, and quick pickups across the city."
    },
    {
        "name": "24/7 Taxi Service Pune",
        "description": "Need a ride at any hour? Meghana Cab offers 24/7 taxi service in Pune to ensure you’re always on the move. Early morning meetings, late-night returns, or emergency travel—we’re here around the clock."
    },
    {
        "name": "City Cabs Pune",
        "description": "Explore Pune with ease using Meghana Cab’s city cab services. Ideal for shopping, dining, or local sightseeing, our city cabs offer comfort, AC convenience, and affordable pricing for short-distance travel."
    },
    {
        "name": "Cab Hire in Pune for Daily Travel",
        "description": "Looking for a cab for your daily commute? Meghana Cab offers flexible daily travel packages within Pune. Enjoy professional service, clean cars, and timely pickups for office, school runs, or errands."
    },
    {
        "name": "Online Taxi in Pune",
        "description": "Book taxis online in Pune quickly and conveniently with Meghana Cab. Our easy-to-use platform allows instant booking, fare estimates, and real-time tracking for a seamless travel experience."
    },
    {
        "name": "Fast Taxi Pune",
        "description": "Get fast and dependable taxi services anywhere in Pune. Meghana Cab ensures minimal wait time and responsive service with our large network of local drivers ready to pick you up on-demand."
    },
    {
        "name": "Pune Taxi with Driver",
        "description": "Hire a cab in Pune with a professional driver for a stress-free experience. Our drivers are well-trained, polite, and knowledgeable about city routes to ensure smooth and efficient travel."
    },
    {
        "name": "Book Local Cab Pune",
        "description": "Booking a local cab in Pune has never been easier. Meghana Cab offers a wide range of vehicle options including hatchbacks, sedans, and SUVs—perfect for individuals, families, or small groups."
    },
    {
        "name": "AC Taxi Services Pune",
        "description": "Stay cool during your city travels with our AC taxi services in Pune. All Meghana Cab vehicles are fully air-conditioned, clean, and maintained for your maximum comfort."
    },
    {
        "name": "Best Taxi Provider in Pune",
        "description": "Choose Meghana Cab as your go-to taxi service provider in Pune. With transparent pricing, excellent customer support, and a fleet of well-maintained cars, we’re trusted by thousands of local riders."
    },
    {
        "name": "Affordable Ride in Pune",
        "description": "Get affordable and value-for-money taxi rides across Pune city with Meghana Cab. Whether short distance or cross-city, we provide budget-friendly cab services without compromising quality."
    },
    {
        "name": "Corporate Taxi in Pune",
        "description": "Meghana Cab offers professional corporate taxi services in Pune for business clients. Schedule rides for employees, executives, or guests with customized billing and dedicated support."
    },
    {
        "name": "Airport Pickup Taxi Pune",
        "description": "Book timely airport pickup taxis in Pune with Meghana Cab. We ensure punctual arrivals at Pune Airport with driver assistance, luggage handling, and smooth city transfers."
    },
    {
        "name": "City Tour Taxi Service Pune",
        "description": "Explore Pune’s top attractions with our city tour taxi service. Our experienced drivers take you to historic sites, local hotspots, and shopping areas in a relaxed and comfortable ride."
    },
    {
        "name": "Call Taxi in Pune",
        "description": "Need a taxi fast? Just call Meghana Cab for quick dispatch service in Pune. No app required—get a cab to your location with a simple phone call anytime, anywhere."
    }
],

"tableData": [
    ["Local Taxi Booking Pune", "24/7 Taxi Service Pune"],
    ["City Cabs Pune", "Cab Hire in Pune for Daily Travel"],
    ["Online Taxi in Pune", "Fast Taxi Pune"],
    ["Pune Taxi with Driver", "Book Local Cab Pune"],
    ["AC Taxi Services Pune", "Best Taxi Provider in Pune"],
    ["Affordable Ride in Pune", "Corporate Taxi in Pune"],
    ["Airport Pickup Taxi Pune", "City Tour Taxi Service Pune"],
    ["Call Taxi in Pune", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Trusted and Affordable Taxi Service in Pune",
        "WhyChoosedescription": "Meghana Cab offers a reliable and budget-friendly taxi service in Pune, suitable for daily commutes, airport transfers, local sightseeing, and business travel. Our taxis are available across all major areas in Pune, providing dependable service for every kind of journey."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicles for Every Need",
        "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and premium cars based on your preferences. Whether you need a quick ride to the market or a full-day rental, we have the right vehicle to match your comfort and budget."
    },
    {
        "WhyChooseheading": "Experienced and Verified Drivers",
        "WhyChoosedescription": "Our drivers are well-trained, licensed, and verified to ensure your safety and peace of mind. They are courteous, punctual, and well-versed with Pune’s routes and traffic patterns, ensuring a smooth ride every time."
    },
    {
        "WhyChooseheading": "24/7 Taxi Availability Across Pune",
        "WhyChoosedescription": "Need a ride early in the morning or late at night? Meghana Cab’s taxi service in Pune is available 24/7, offering reliable transportation whenever you need it, including weekends and holidays."
    },
    {
        "WhyChooseheading": "Clean, Comfortable & Sanitized Cabs",
        "WhyChoosedescription": "Our fleet is regularly cleaned, fully air-conditioned, and sanitized after every ride to ensure the highest level of hygiene and comfort for our passengers."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "With Meghana Cab, you always know what you're paying for. We offer clear, upfront pricing with no surprises—what you see is what you pay."
    },
    {
        "WhyChooseheading": "Quick Booking and Easy Cancellations",
        "WhyChoosedescription": "Book your taxi through our website, mobile app, or by phone. Our user-friendly booking system provides instant confirmations, and we offer flexible cancellations with minimal hassle."
    },
    {
        "WhyChooseheading": "Local, Outstation, and Airport Taxi Services",
        "WhyChoosedescription": "Whether you need a short ride within Pune, a day trip outside the city, or a drop-off to Pune or Mumbai Airport, Meghana Cab is your go-to choice for all types of travel requirements."
    }
]









































    }

const faqData = [
    {
        question: "How can I book a taxi service in Pune with Meghana Cab?",
        answer: "You can book taxi services in Pune by calling Meghana Cab at +91 9075462128 or using our website for easy booking."
    },
    {
        question: "What types of taxis are available in Pune?",
        answer: "We offer sedans, SUVs, and tempo travellers to suit different group sizes and travel needs."
    },
    {
        question: "Are Meghana Cab drivers experienced with Pune city routes?",
        answer: "Yes, our drivers are knowledgeable about Pune’s routes to ensure timely and safe travel."
    },
    {
        question: "Can I book a taxi for local Pune travel or outstation trips?",
        answer: "Yes, we provide both local taxi services within Pune and outstation trips from Pune."
    },
    {
        question: "What is included in the Pune taxi service fare?",
        answer: "The fare includes driver charges, fuel, and vehicle maintenance. Additional charges such as tolls and parking may apply."
    },
    {
        question: "Is Meghana Cab available 24/7 for taxi services in Pune?",
        answer: "Yes, we operate round-the-clock to provide taxi services anytime you need."
    },
    {
        question: "Can I book a taxi for an hourly rental in Pune?",
        answer: "Yes, hourly rentals are available for local travel within Pune."
    },
    {
        question: "Are vehicles sanitized and safe for passengers?",
        answer: "All our vehicles are regularly cleaned and sanitized to ensure your safety and comfort."
    },
    {
        question: "What payment methods are accepted for Pune taxi bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "How can I contact Meghana Cab for taxi services in Pune?",
        answer: "Call Meghana Cab at +91 9075462128 to book or inquire about taxi services in Pune."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Ajay Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab offers reliable and comfortable taxi service in Pune. The drivers are professional and punctual.”',
    },
    {
        name: 'Ms. Priyanka Sharma',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I had a great experience with Meghana Cab’s Pune taxi service. Highly recommended for local travel.”',
    },
];



































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Taxi Service in Pune",
  "image": "https://www.meghanacabs.com/assets/images/taxi-service-in-pune.jpg",
  "description": "Meghana Cabs offers reliable taxi service in Pune for local travel, airport pickups, corporate rides, and city tours. Book 24/7 AC cabs with experienced drivers at affordable rates.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5923"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/taxi-service-in-pune"
  }
};







    return (
        <div>


<Helmet>
  <title>Taxi Service in Pune | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Meghana Cabs offers reliable taxi service in Pune for local travel, airport pickups, corporate rides, and city tours. Book 24/7 AC cabs with experienced drivers at affordable rates." 
  />
  <meta 
    name="keywords" 
    content="Local Taxi Booking Pune, 24/7 Taxi Service Pune, City Cabs Pune, Cab Hire in Pune for Daily Travel, Online Taxi in Pune, Fast Taxi Pune, Pune Taxi with Driver, Book Local Cab Pune, AC Taxi Services Pune, Best Taxi Provider in Pune, Affordable Ride in Pune, Corporate Taxi in Pune, Airport Pickup Taxi Pune, City Tour Taxi Service Pune, Call Taxi in Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/32.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Taxiserviceinpune;